import useGlobalConfig from "@/store/global";
import Alphanine from "./alphanine.jsx";
import Coagadex from "./coagadex.jsx";
import Gammaked from "./gammaked.jsx"
import Gamunex from "./gamunex.jsx";
import Prolastin from "./prolastin.jsx";
import Xembify from "./xembify.jsx";
import Kedrab from "./kedrab.jsx";

const ProgramIntroduction = () => {
  const { program } = useGlobalConfig();
  const name = program.name

  switch (name) {
    case "alphanine":
      return <Alphanine />;
    case "coagadex":
      return <Coagadex />;
    case "gammaked":
      return <Gammaked />;
    case "gamunex":
      return <Gamunex />;
    case "kedrab":
      return <Kedrab />;
    case "prolastin":
      return <Prolastin />;
    case "xembify":
      return <Xembify />;
    default:
      return null
  }
};

export default ProgramIntroduction